<template>
    <div class="google-login" >
        <div class="center-box" v-if="!secondShow" @keyup.enter="showNext">
            <div class="title-area">
                <span class="title-text">谷歌验证器绑定</span>
            </div>
            <div class="center-area">
                <div class="tips-text">
                    <span>1、请确保您的手机已安装谷歌验证器。</span>
                    <span>2、请打开您的谷歌验证器APP，扫描下面二维码或输入绑定密钥进行绑定：</span>
                </div>
                <div class="qrcode-area">
                    <img class="qrcode-img" :src="qrCode"/>
                </div>
                <div class="secret-area">
                    <span>绑定密钥：{{secretCode}}</span>
                    <el-button type="text" style="font-size: 15px;text-align: center;margin-left: 20px;" @click="copySecretCode">复制</el-button>
                </div>
            </div>
            <div class="bottom-area">
                <el-button type="primary" size="small" @click="showNext" style="width: 120px;margin-right: 50px;">下一步</el-button>
            </div>
        </div>
        <div class="center-box" v-else @keyup.enter="processLogin">
            <div class="title-area">
                <span style="font-size: 20px;position: absolute;left:10px;" v-if="!hasBinded"><</span>
                <span style="font-size: 18px;position: absolute;left:30px;" @click="goBack" v-if="!hasBinded">返回</span>
                <span class="title-text" v-if="!hasBinded">输入代码</span>
                <span class="title-text" v-if="hasBinded">谷歌验证器验证</span>
            </div>
            <div class="center-area">
                <div class="tips-text">
                    <span>请输入谷歌动态验证码：</span>
                </div>
                <el-input style="width:90%;" v-model="googleCode"></el-input>
            </div>
            <div class="bottom-area" v-if="!hasBinded">
                <el-button type="primary" size="small" @click="loginAndBind" style="width: 120px;margin-right: 50px;">登录并绑定</el-button>
            </div>
            <div class="bottom-area" v-else>
                <el-button type="primary" size="small" @click="googleLogin" style="width: 120px;margin-right: 50px;">验证登录</el-button>
            </div>
        </div>
    </div>
</template>

<script>
    let that
    export default {
        name: "GoogleLogin",
        data () {
            return {
                hasBinded: false,
                secondShow: false,
                googleCode: '',
                qrCode: '',
                secretCode: 'aa-bb-cc-dd'
            }
        },
        mounted() {
            // console.log("hasBinded is " + this.$route.query.hasBinded)
            if (!this.$store.state.userInfo.isBindGoogleAuthenticator) {
                this.hasBinded = false
                this.secondShow = false
                this.getGoogleBindCode()
            }
            else {
                this.hasBinded = true
                this.secondShow = true
            }
        },
        methods: {
            processLogin() {
                // console.log("processLogin")
              if (this.hasBinded) {
                  this.googleLogin()
              }  else {
                  this.loginAndBind()
              }
            },
            getGoogleBindCode(){
                this.$post(this.$uri.user.getGoogleAuthenticator).then(res=> {
                    if (res.success) {
                        this.qrCode = res.data.qrBase64
                        this.secretCode = res.data.secret
                    }
                })
            },
            loginAndBind() {
                // console.log("loginAndBind")
                let that = this
                // console.log("bind googleCode is " + that.googleCode)
                this.$post(this.$uri.user.bindGoogleAuthenticator, {googleCode: that.googleCode}).then(res => {
                    // console.log("res is " + JSON.stringify(res))
                    if (res.success) {
                        that.$router.push("/home")
                    }
                })
            },
            goBack() {
              this.secondShow = false
            },
            showNext() {
                this.secondShow = true
            },
            copySecretCode() {
                this.$copyText(this.secretCode).then(() => {
                    this.$message.success("复制成功")
                }, () => {
                    this.$message.error("复制失败")
                })
            },
            googleLogin() {
                if (this.googleCode.length > 0) {
                    var param = {
                        id: this.$store.state.userInfo.id,
                        googleCode: this.googleCode
                    }
                    // console.log("param is " + JSON.stringify(param))
                    this.$store.dispatch(this.$action.GOOGLE_LOGIN, param)
                }
            }
        }
    }
</script>

<style scoped>
    .google-login {
        width: 100vw;
        height: 100vh;
        /*min-height: 700px;*/
        background: #f1f0f3;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
    }
.center-box{
    width: 700px;
    height: 420px;
    background: white;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    border: 1px solid darkgray;
}
.title-area {
    position: relative;
    width: 100%;
    height: 60px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    border-bottom: 1px solid darkgray;
}
    .title-text {
        font-size: 20px;
        font-weight: bold;
    }
    .center-area{
        width: 100%;
        height: 300px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }
    .tips-text{
        margin-top: 15px;
        width: 90%;
        height: 60px;
        /*background: yellow;*/
        display: flex;
        flex-direction: column;
        align-items: flex-start;
    }
    .tips-text span{
        font-size: 15px;
        line-height: 30px;
        text-align: center;
        /*margin-left: 20px;*/
    }
    .qrcode-area {
        width: 100%;
        height: 180px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
    }
    .qrcode-img {
        width: 160px;
        height: 160px;
        /*background: red;*/
    }
    .secret-area {
        width: 100%;
        height: 50px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
    }
    .bottom-area {
        width: 100%;
        height:40px;
        display: flex;
        flex-direction: row;
        align-items: flex-end;
        justify-content: flex-end;
    }
</style>